// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".topfavoriteicon button {\n  color: #fff !important;\n  background: inherit;\n  border-width: 0px;\n  cursor: pointer;\n}\n.right-sidebar-menu-top-btn button {\n  color: #fff !important;\n  background: inherit;\n  border-width: 0px;\n  cursor: pointer;\n}", ""]);
// Exports
module.exports = exports;
